export default "__VITE_ASSET__wEaXwcP3__"